<template>
  <header class="content_header">
    <v-container>
      <v-row>
        <v-col cols="4" sm="4" class="cols-header">
          <div class="header">
            <img class="img" src="@/assets/images/cal-hor.png" />
            <span class="text">{{ dataArray.formattedDate }}</span>
          </div>
        </v-col>

        <v-col cols="4" sm="4" class="cols-header">
          <div class="header">
            <img class="img" src="@/assets/images/user.jpg" />
            <span class="text-header">Bienvenido {{ username }}  <br> {{ dispatch  }} ({{ typeUser }})</span>
          </div>
        </v-col>

        <v-col cols="4" sm="4" class="cols-header">
          <div class="header">
            <v-btn variant="plain" class="notifications" @click="openDialog">
              <v-badge :content="totalNotificaciones" color="error">
                <img class="img" src="@/assets/images/img-campana.png" />
              </v-badge>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <AlertComponent :value="dialogData" />
      <SnackbarComponent :value="snackbarData" />
    </v-container>

    <!--Dialog de notificaciones-->
    <template>
      <v-dialog width="500" v-model="dialgNotifications">
        <v-card title="Notificaciones">
          <v-divider class="mx-3"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="md-12">
                <v-text-field
                  v-model="fecha"
                  placeholder="Clic para seleccionar la fecha"
                  readonly
                  @click="openDialogDate()"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <!--<v-container>-->
            <div v-if="!loadingCampana">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-title> Notas </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-list>
                      <div
                        class="content_accion"
                        v-for="note in listNotes"
                        :key="note.id_gestion"
                      >
                        <div class="checks">
                          <v-switch
                            class="switch"
                            v-model="estatus"
                            color="success"
                            @change="openDialogChange('note', note.id_gestion)"
                          ></v-switch>
                        </div>
                        <div class="divs-data">
                          <v-list-item-title class="listas"
                            >Cliente: {{ note.id_cliente }}</v-list-item-title
                          >
                          <v-list-item-subtitle class="listas"
                            >Fecha:{{
                              note.fecha_hora_contactar
                            }}</v-list-item-subtitle
                          >
                          <v-list-item-subtitle class="listas"
                            >Comentario:
                            {{ note.comentario }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title> Avisos </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-list>
                      <div
                        class="content_accion"
                        v-for="notice in listNotices"
                        :key="notice.id_aviso"
                      >
                        <div class="checks">
                          <v-switch
                            class="switch"
                            v-model="estatus"
                            color="success"
                            @change="
                              openDialogChange('notice', notice.id_aviso)
                            "
                          ></v-switch>
                        </div>
                        <div class="divs-data">
                          <v-list-item-title class="listas"
                            >Titulo: {{ notice.titulo }}</v-list-item-title
                          >
                          <v-list-item-subtitle class="listas"
                            >Descripción:
                            {{ notice.descripcion }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel
                  v-if="typeUser == 'Colaborador' || typeUser == 'Gestor'"
                >
                  <v-expansion-panel-title>
                    Pagos Vencidos
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-data-table
                      class="content_table"
                      :headers="headersPayments"
                      fixed-header
                      :items="listPayments"
                      :items-per-page="itemsPerPage"
                    >
                    </v-data-table>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel
                  v-if="typeUser == 'Colaborador' || typeUser == 'Gestor'"
                >
                  <v-expansion-panel-title>
                    Convenios Cancelados
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-data-table
                      class="content_table"
                      :headers="headersAgreement"
                      fixed-header
                      :items="listAgreements"
                      :items-per-page="itemsPerPage"
                    >
                    </v-data-table>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>

            <div class="content_load" v-if="loadingCampana">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
            <!--</v-container>-->
          </v-card-text>
          <v-divider class="mx-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              variant="flat"
              class="text-none mb-4"
              text="Cerrar"
              color="red"
              prepend-icon="mdi-close"
              @click="closeDialog"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Seleccione una Fecha -->
    <template>
      <v-dialog v-model="dialogDate" width="400px" persistent>
        <v-card>
          <v-card-title>
            <div>
              <span class="text-h5">Seleccione una Fecha</span>
            </div>
          </v-card-title>

          <v-card-text>
            <v-date-picker
              v-model="inputDate"
              :min="minDate"
              @click="selectedDate()"
            >
            </v-date-picker>
          </v-card-text>
          <v-divider class="mx-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              variant="flat"
              class="text-none mb-4"
              text="Aceptar"
              color="indigo-darken-3"
              prepend-icon="mdi-content-save"
              @click="closeDialogDate"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!--Dialog de confirmación-->
    <template>
      <v-dialog v-model="dialogDelete" width="500px" persistent>
        <v-card>
          <v-card-title>
            <span class="text-h5">Confirmación</span>
          </v-card-title>
          <v-card-text>
            <div v-if="!isLoadingEliminar">
              <div class="text-center">
                <img class="img-confirm" src="@/assets/images/warning.png" />
              </div>
              <div class="description-text">
                <p v-if="tipoCheck === 'note'">
                  ¿Está seguro de marcar como completada la <b>nota</b>?
                </p>
                <p v-if="tipoCheck === 'notice'">
                  ¿Está seguro de marcar como completada la <b>aviso</b>?
                </p>
              </div>
            </div>
            <div class="content_load" v-if="isLoadingEliminar">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-card-text>
          <v-card-actions class="actions-buttons">
            <v-spacer></v-spacer>
            <v-btn
              variant="flat"
              class="text-none"
              color="red"
              prepend-icon="mdi-close"
              @click="closeDialogChange"
              >Cerrar</v-btn
            >
            <v-btn
              v-if="tipoCheck === 'note'"
              :loading="isLoadingEliminar"
              variant="flat"
              class="text-none"
              color="indigo-darken-3"
              prepend-icon="mdi-content-save"
              @click="changeStatus"
              >Aceptar</v-btn
            >
            <v-btn
              v-if="tipoCheck === 'notice'"
              variant="flat"
              class="text-none"
              color="indigo-darken-3"
              prepend-icon="mdi-content-save"
              :loading="isLoadingEliminar"
              @click="changeStatusNotice"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </header>
</template>

<script>
import { EncryptService } from "@/services/EncryptService";
import { HeaderService } from "@/services/HeaderService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";
import { ResourcesService } from "@/services/ResourcesService";

export default {
  name: "HeaderComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      typeUser: String,
      username: String,
      dispatch: String,
      dataArray: {
        weekday: "",
        mes: "",
        dt: "",
        formattedDate: "",
      },
      dialgNotifications: false,
      listNotes: [],
      listNotices: [],
      listPayments: [],
      listAgreements: [],
      dialogDate: false,
      headersPayments: [
        { title: "Cliente", key: "id_cliente" },
        { title: "Pago Esperado", key: "pago_esperado" },
      ],
      itemsPerPage: 5,
      headersAgreement: [
        { title: "Cliente", key: "id_cliente" },
        { title: "Clasificación", key: "clasificacion_especial" },
        { title: "Días de atraso", key: "atraso_max" },
      ],
      fecha: "",
      inputDate: new Date(),
      loadingCampana: false,
      totalNotificaciones: 0,
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      isLoadingEliminar: false,
      dialogDelete: false,
      idGestionGlobal: "",
      estatus: false,
      seguirEjecutando: "",
      idNotices: null,
      tipoCheck: null,
    };
  },
  async mounted() {
    this.seguirEjecutando = setInterval(() => {
      this.getDataNotifications();
    }, 300000);
  },
  beforeUnmount() {
    clearInterval(this.seguirEjecutando);
  },
  async beforeMount() {
    this.typeUser = await EncryptService.decrypt(localStorage.getItem("TIPO"));
    this.dispatch = await EncryptService.decrypt(localStorage.getItem("DESPACHO"));
    this.username =
      localStorage.getItem("NAME") + " " + localStorage.getItem("LAST_NAME");
    this.viewAndData();
    this.getDataNotifications();
  },
  methods: {
    viewAndData() {
      const now = new Date();

      const weekDays = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      function getWeekNumber(date) {
        const target = new Date(date.valueOf());
        const dayNumber = (date.getDay() + 6) % 7; // Lunes = 0, Domingo = 6
        target.setDate(target.getDate() - dayNumber + 3); // Al jueves de la semana
        const firstThursday = new Date(target.getFullYear(), 0, 4);
        const diff = target - firstThursday;
        return 1 + Math.round(diff / (7 * 24 * 60 * 60 * 1000));
      }

      const weekday = weekDays[now.getDay()];
      const mes = months[now.getMonth()];
      const dt = getWeekNumber(now);

      const formattedDate = `${weekday} ${now.getDate()} de ${mes} del ${now.getFullYear()} Semana: ${dt
        .toString()
        .padStart(2, "0")}`;

      this.dataArray = {
        weekday,
        mes,
        dt,
        formattedDate,
      };
    },
    getWeekNumber(date) {
      const startOfYear = new Date(date.getFullYear(), 0, 1);
      const diff = date - startOfYear;
      const oneWeek = 1000 * 60 * 60 * 24 * 7;
      const weekNumber = Math.ceil(diff / oneWeek);
      return weekNumber;
    },
    openDialog() {
      this.dialgNotifications = true;
      this.getDataNotifications();
    },
    closeDialog() {
      this.dialgNotifications = false;
      this.fecha = "";
    },
    getDataNotifications: async function () {
      this.loadingCampana = true;

      let day = "";
      let month = "";
      let year = "";
      if (this.fecha == "") {
        const currentDate = new Date();
        day = ("0" + currentDate.getDate()).slice(-2);
        month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        year = currentDate.getFullYear();
      } else {
        const currentDate = new Date(this.fecha);
        day = ("0" + (currentDate.getDate() + 1)).slice(-2);
        month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        year = currentDate.getFullYear();
      }

      let idU = await HeaderService.encriptar(localStorage.getItem("ID"));
      await HeaderService.getDataNotifications(day, month, year, idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listNotes = resp.response.notes;
            this.listNotices = resp.response.notices;
            this.listPayments = resp.response.payments;
            this.listAgreements = resp.response.agreements;
            this.listNotes.forEach((element) => {
              if (element.comentario.length > 30) {
                let coment = element.comentario.substring(0, 30);
                element.comentario = coment + "...";
              }
            });

            if (
              this.typeUser == "Administrador" ||
              this.typeUser == "Supervisor"
            ) {
              let total = 
                this.listNotices.length + 
                this.listNotes.length

              this.totalNotificaciones = total;
            }

            if (this.typeUser == "Gestor" || this.typeUser == "Colaborador") {
              let total =
                this.listNotices.length +
                this.listNotes.length +
                this.listPayments.length +
                this.listAgreements.length;
              this.totalNotificaciones = total;
            }

            setTimeout(() => {
              this.loadingCampana = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
            ResourcesService.checkErrors(resp);
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    closeDialogDate: async function () {
      this.dialogDate = false;
      this.loadingCampana = true;
      let fechaSplit = this.fecha.split("-");
      let day = fechaSplit[2];
      let month = fechaSplit[1];
      let year = fechaSplit[0];

      let idU = await HeaderService.encriptar(localStorage.getItem("ID"));
      await HeaderService.getDataNotifications(day, month, year, idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listNotes = resp.response.notes;
            this.listNotices = resp.response.notices;
            this.listPayments = resp.response.payments;
            this.listAgreements = resp.response.agreements;
            this.listNotes.forEach((element) => {
              if (element.comentario.length > 30) {
                let coment = element.comentario.substring(0, 30);
                element.comentario = coment + "...";
              }
            });

            if (
              this.typeUser == "Administrador" ||
              this.typeUser == "Supervisor"
            ) {
              this.totalNotificaciones = this.listNotices.length;
            }

            if (this.typeUser == "Gestor" || this.typeUser == "Colaborador") {
              let total =
                this.listNotices.length +
                this.listNotes.length +
                this.listPayments.length +
                this.listAgreements.length;
              this.totalNotificaciones = total;
            }
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.loadingCampana = false;
    },
    openDialogDate() {
      this.dialogDate = true;
    },
    selectedDate: function () {
      const YEAR_INPUT = this.inputDate.getFullYear();
      const MONTH_INPUT = ("0" + (this.inputDate.getMonth() + 1)).slice(-2);
      const DAY_INPUT = ("0" + this.inputDate.getDate()).slice(-2);
      const DATE_SELECTED = `${DAY_INPUT}-${MONTH_INPUT}-${YEAR_INPUT}`;
      this.fecha = DATE_SELECTED;
    },
    openDialogChange(tipo, id) {
      this.tipoCheck = tipo;
      if (tipo == "note") {
        this.idGestionGlobal = id;
      }

      if (tipo == "notice") {
        this.idNotices = id;
      }

      this.dialogDelete = true;
    },
    changeStatus: async function () {
      this.isLoadingEliminar = true;
      this.loadingCampana = true;
      let idG = await HeaderService.encriptar(this.idGestionGlobal);
      const formData = new FormData();
      formData.append("id_gestion", idG.msg);
      await HeaderService.changeStatus(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Nota actualizada con exito!",
            };
            setTimeout(() => {
              this.loadingCampana = false;
            }, 1000);
            this.getDataNotifications();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.dialogDelete = false;
      this.isLoadingEliminar = false;
      this.idGestionGlobal = "";
      this.estatus = false;
    },
    closeDialogChange() {
      this.dialogDelete = false;
      this.estatus = false;
      this.idGestionGlobal = "";
    },
    changeStatusNotice: async function () {
      this.isLoadingEliminar = true;
      this.loadingCampana = true;
      let idG = await HeaderService.encriptar(this.idNotices);
      const formData = new FormData();
      formData.append("id_aviso", idG.msg);
      await HeaderService.changeStatusNotices(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Aviso actualizado con exito!",
            };
            setTimeout(() => {
              this.loadingCampana = false;
            }, 1000);
            this.getDataNotifications();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.dialogDelete = false;
      this.isLoadingEliminar = false;
      this.idNotices = "";
      this.estatus = false;
    },
  },
};
</script>

<style scoped>
.content_header {
  height: 11vh;
}

.cols-header {
  padding-top: 0px;
}
.header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img {
  border-radius: 50%;
  width: 5vh;
  height: 5vh;
}

.text {
  text-align: center;
  font-size: 11px;
  margin-top: 5px;
  width: 25vh;
}

.text-header{
  text-align: center;
  font-size: 11px;
  margin-top: 5px;
  width: 35vh;
}

.notifications {
  margin-top: 2vh;
}

.listas {
  font-size: 13px;
}

.checks {
  float: left;
  align-items: start;
}

.divs-data {
  width: 60vh;
}

.img-confirm {
  height: 230px;
  width: auto;
  padding: 40px;
}

.content_accion {
  height: 15vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.switch {
  width: 10vh;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}
@media (max-width: 599px) {
  .text, .text-header { width: 100%; overflow-wrap: anywhere; }
  .header { min-width: 0; }
}
</style>
